// extracted by mini-css-extract-plugin
export var footer = "_8g_qu";